module.exports = __webpack_public_path__ + "4f589f4867dbd57estep_3.961132b3.png";